import { styled, Stack } from '@mui/material';

export const StyledStack = styled(Stack)`
  width: 100%;
`;